import { BaseAction, DataAction } from 'src/CustomTypes'
import { SET_TOKEN, SET_USER_CREDENTIALS, LOGIN_SUCCESS, LOGIN_FAILURE, LOGIN_STARTED, LOGOUT, SET_TOKEN_EXPIRED, TokenBundle, UserCredentials } from '../actions/AuthAction'

export interface AuthState {
  loginInProgress: boolean
  isLoggedIn: boolean
  isLoginError: boolean
  token: string
  tokenExpirationTimestamp?: number
  username: string
  password: string
}

export const authStateInitial: AuthState = {
  loginInProgress: false,
  isLoggedIn: false,
  isLoginError: false,
  token: '',
  tokenExpirationTimestamp: undefined,
  username: '',
  password: ''
}

export function authReducer (
  state: AuthState = authStateInitial, // eslint-disable-line @typescript-eslint/default-param-last
  action: BaseAction): AuthState {
  switch (action.type) {
    case SET_TOKEN: {
      const a = action as DataAction<TokenBundle>
      return {
        ...state,
        token: a.data.token,
        loginInProgress: false,
        isLoggedIn: true,
        tokenExpirationTimestamp: a.data.tokenExpirationTimestamp
      }
    }
    case SET_USER_CREDENTIALS: {
      const a = action as DataAction<UserCredentials>
      return {
        ...state,
        username: a.data.username,
        password: a.data.password
      }
    }
    case SET_TOKEN_EXPIRED: {
      return {
        ...state,
        loginInProgress: false,
        isLoggedIn: false,
        token: '',
        tokenExpirationTimestamp: undefined
      }
    }
    case LOGIN_STARTED: {
      return {
        ...state,
        loginInProgress: true,
        isLoginError: false
      }
    }
    case LOGIN_SUCCESS: {
      return {
        ...state,
        loginInProgress: false,
        isLoggedIn: true,
        isLoginError: false
      }
    }
    case LOGIN_FAILURE: {
      return {
        ...state,
        loginInProgress: false,
        isLoginError: true
      }
    }
    case LOGOUT: {
      return {
        ...state,
        isLoggedIn: false,
        isLoginError: false,
        loginInProgress: false,
        username: '',
        password: '',
        token: '',
        tokenExpirationTimestamp: undefined
      }
    }
    default:
      return state
  }
}
